(function () {
  function initVideoShells(scope) {
    (scope || document).querySelectorAll('[data-zeriva-video-shell]:not([data-zeriva-video-ready])').forEach(function (shell) {
      shell.dataset.zerivaVideoReady = 'true';
      var button = shell.querySelector('[data-zeriva-video-play]');
      var template = shell.querySelector('[data-zeriva-video-template]');
      if (!button || !template) return;

      button.addEventListener('click', function () {
        var fragment = template.content.cloneNode(true);
        shell.innerHTML = '';
        shell.appendChild(fragment);
        var video = shell.querySelector('video');
        if (video && typeof video.play === 'function') {
          video.play().catch(function () {});
        }
      });
    });
  }

  function buildSectionUrl(rawUrl, sectionId) {
    var url = new URL(rawUrl, window.location.origin);
    if (sectionId) url.searchParams.set('section_id', sectionId);
    return url.toString();
  }

  function extractReviewText(value, depth) {
    if ((depth || 0) > 12 || value === null || value === undefined) return '';
    if (Array.isArray(value)) {
      return value.map(function (item) { return extractReviewText(item, (depth || 0) + 1); }).filter(Boolean).join('\n').trim();
    }
    if (typeof value === 'object') {
      var keys = ['text', 'body', 'review', 'comment', 'content', 'value', 'children'];
      for (var index = 0; index < keys.length; index += 1) {
        if (value[keys[index]] !== undefined) {
          var nested = extractReviewText(value[keys[index]], (depth || 0) + 1);
          if (nested) return nested;
        }
      }
      return '';
    }
    var text = String(value).trim();
    if (!text || (text.charAt(0) !== '{' && text.charAt(0) !== '[')) return text;
    try {
      return extractReviewText(JSON.parse(text), (depth || 0) + 1);
    } catch (_error) {
      return text;
    }
  }

  function cleanReviewText(value) {
    return extractReviewText(value, 0);
  }

  function initReviews(scope) {
    (scope || document).querySelectorAll('[data-zeriva-reviews]:not([data-zeriva-reviews-ready])').forEach(function (root) {
      root.dataset.zerivaReviewsReady = 'true';
      var liveRegion = root.querySelector('[data-zeriva-reviews-live]');
      var revealButton = root.querySelector('[data-zeriva-reviews-reveal]');
      var reviewGrid = root.querySelector('[data-zeriva-reviews-grid]');
      if (reviewGrid) {
        Array.prototype.slice.call(reviewGrid.querySelectorAll('[data-zeriva-review-card]'))
          .sort(function (firstCard, secondCard) {
            var firstRating = Number(firstCard.dataset.zerivaReviewRating || 0);
            var secondRating = Number(secondCard.dataset.zerivaReviewRating || 0);
            if (secondRating !== firstRating) return secondRating - firstRating;
            return Number(firstCard.dataset.zerivaReviewIndex || 0) - Number(secondCard.dataset.zerivaReviewIndex || 0);
          })
          .forEach(function (card, index) {
            card.dataset.zerivaReviewIndex = String(index + 1);
            reviewGrid.appendChild(card);
          });
      }
      var cards = Array.prototype.slice.call(root.querySelectorAll('[data-zeriva-review-card]'));
      var pageButtons = Array.prototype.slice.call(root.querySelectorAll('[data-zeriva-reviews-local-page]'));
      var previousButton = root.querySelector('[data-zeriva-reviews-prev]');
      var nextButton = root.querySelector('[data-zeriva-reviews-next]');
      var pagination = root.querySelector('[data-zeriva-reviews-pagination]');
      var currentPage = 1;
      var pageSize = 10;
      var expanded = false;

      function pauseHiddenVideos() {
        cards.forEach(function (card) {
          if (card.dataset.zerivaReviewHidden !== 'true') return;
          card.querySelectorAll('video').forEach(function (video) {
            if (typeof video.pause === 'function') video.pause();
          });
        });
      }

      root.querySelectorAll('.zeriva-review-card__body').forEach(function (body) {
        var cleaned = cleanReviewText(body.textContent);
        if (cleaned && cleaned !== body.textContent.trim()) body.textContent = cleaned;
      });

      function renderPage(page) {
        currentPage = page;
        var start = (page - 1) * pageSize;
        var end = start + (expanded ? pageSize : 5);
        cards.forEach(function (card, index) {
          card.dataset.zerivaReviewHidden = index < start || index >= end ? 'true' : 'false';
        });
        pageButtons.forEach(function (button) {
          var active = Number(button.dataset.zerivaReviewsLocalPage) === page;
          button.classList.toggle('is-current', active);
          if (active) button.setAttribute('aria-current', 'page');
          else button.removeAttribute('aria-current');
        });
        if (previousButton) previousButton.disabled = page <= 1;
        if (nextButton) nextButton.disabled = page >= Math.ceil(cards.length / pageSize);
        if (pagination) pagination.hidden = !expanded;
        if (revealButton) {
          revealButton.closest('.zeriva-reviews__actions').hidden = expanded || cards.length <= 5;
          revealButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        }
        pauseHiddenVideos();
      }

      function scrollToFirstVisibleReview() {
        var firstVisibleCard = cards.find(function (card) {
          return card.dataset.zerivaReviewHidden !== 'true';
        });
        if (!firstVisibleCard) return;
        window.requestAnimationFrame(function () {
          firstVisibleCard.scrollIntoView({
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
            block: 'start'
          });
        });
      }

      function changePage(page) {
        renderPage(page);
        scrollToFirstVisibleReview();
      }

      renderPage(1);

      if (revealButton) {
        revealButton.addEventListener('click', function () {
          expanded = true;
          renderPage(1);
          if (liveRegion) liveRegion.textContent = 'Cinco comentarios adicionales visibles.';
        });
      }

      pageButtons.forEach(function (button) {
        button.addEventListener('click', function () {
          if (!expanded) return;
          changePage(Number(button.dataset.zerivaReviewsLocalPage));
        });
      });
      if (previousButton) previousButton.addEventListener('click', function () {
        if (expanded && currentPage > 1) changePage(currentPage - 1);
      });
      if (nextButton) nextButton.addEventListener('click', function () {
        if (expanded && currentPage < Math.ceil(cards.length / pageSize)) changePage(currentPage + 1);
      });

      root.querySelectorAll('[data-zeriva-reviews-page]').forEach(function (button) {
        button.addEventListener('click', function () {
          var rawUrl = button.dataset.zerivaReviewsPage;
          if (!rawUrl) return;
          root.querySelectorAll('video').forEach(function (video) {
            if (typeof video.pause === 'function') video.pause();
          });
          var url = buildSectionUrl(rawUrl, button.dataset.sectionId);
          button.disabled = true;
          fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
            .then(function (response) {
              if (!response.ok) throw new Error('network');
              return response.text();
            })
            .then(function (html) {
              var doc = new DOMParser().parseFromString(html, 'text/html');
              var next = doc.querySelector('[data-zeriva-reviews]');
              if (!next) throw new Error('missing-section');
              root.replaceWith(next);
              initReviews(document);
              initVideoShells(document);
              next.scrollIntoView({ behavior: 'smooth', block: 'start' });
              var focusTarget = next.querySelector('[data-zeriva-reviews-heading]') || next;
              focusTarget.setAttribute('tabindex', '-1');
              focusTarget.focus({ preventScroll: true });
            })
            .catch(function () {
              button.disabled = false;
              if (liveRegion) liveRegion.textContent = 'No fue posible cargar mas opiniones. Intentalo nuevamente.';
            });
        });
      });

      var form = root.querySelector('[data-zeriva-review-form]');
      var success = root.querySelector('[data-zeriva-review-success]');
      if (form && success) {
        form.addEventListener('submit', function (event) {
          event.preventDefault();
          form.reset();
          success.hidden = false;
        });
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initVideoShells(document);
    initReviews(document);
  });

  document.addEventListener('shopify:section:load', function (event) {
    initVideoShells(event.target);
    initReviews(event.target);
  });
})();
